export default "__VITE_ASSET__078046a1__"